module.exports = "/fonts/payjak-logotype-l-3921ad5b6fa7ef216c862eb6360f3301.svg";